import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../css/myrequests.css";
import { useJobContext } from "../../context/JobContext";
import { getUserJobs, deleteJob, toggleJobStatus } from "../../services/jobsService";

import StatusTabs from "./components/StatusTabs";
import RequestsList from "./components/RequestsList";
import Spinner from "../../utils/Spinner";


const MyRequests = () => {
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("active");
    const { requests, setRequests, setShowAddJob, openEditJob } = useJobContext();

    useEffect(() => {
        const fetchRequests = async () => {
            try {
                setLoading(true);
                const data = await getUserJobs();
                setRequests(data);
            } catch (error) {
                console.error(error);
                toast.error("Failed to load your requests.");
            } finally {
                setLoading(false);
            }
        };
        fetchRequests();
    }, []);

    const handleDeleteRequest = async (jobId) => {
        const confirmDelete = window.confirm(
            "Are you sure you want to delete service request?"
        );

        if (!confirmDelete) return; // User canceled

        try {
            await deleteJob(jobId);
            setRequests((prev) => prev.filter((r) => r.id !== jobId));
            toast.success("Request deleted successfully.");
        } catch (error) {
            console.error(error);
            toast.error("Failed to delete request.");
        }
    };

    const toggleJobStatusHandler = async (jobId) => {
        try {
            const data = await toggleJobStatus(jobId);

            setRequests((prev) =>
                prev.map((job) =>
                    job.id === jobId ? { ...job, status: data.status } : job
                )
            );

            toast.success(`Job marked as ${data.status}`);
        } catch (err) {
            toast.error("Failed to update job status.");
        }
    };

    const editRequest = (request) => openEditJob(request);

    // Count quick metrics
    const counts = {
        active: requests.filter(r => r.status === "active").length,
        completed: requests.filter(r => r.status === "completed").length,
        total: requests.length,
    };

    // Determine what to show
    const filteredRequests =
        activeTab === "total"
            ? requests
            : requests.filter(r => r.status === activeTab);



    // Main render
    if (loading) {
        return <Spinner />; // Show spinner while loading
    }

    return (
        <div className="my-requests-page">
            <StatusTabs counts={counts} activeTab={activeTab} setActiveTab={setActiveTab} />

            <div className="header-row">
                <button className="add-job-button" onClick={() => setShowAddJob(true)}>
                    <i className="fa-solid fa-plus"></i> Request Service
                </button>
            </div>
            {filteredRequests.length === 0 ? (
                <div className="empty-state">No requests found.</div>
            ) : (
                <RequestsList
                    requests={filteredRequests}
                    handleDeleteRequest={handleDeleteRequest}
                    editRequest={editRequest}
                    toggleJobStatusHandler={toggleJobStatusHandler}
                    activeTab={activeTab}
                />
            )}

        </div>
    );
};

export default MyRequests;